class StickySidebar extends HTMLElement {
  topGap: number = 0;
  bottomGap: number = 0;
  currPos: number = 0;
  screenHeight: number = 0;
  stickyElementHeight: number = 0;
  endScroll: number = 0;
  _boundUpdateSticky: () => void;
  _boundHandleResize: () => void;

  constructor() {
    super();

    // Initialize properties
    this.topGap = 0;
    this.bottomGap = 0;
    this.currPos = window.scrollY;
    this.screenHeight = window.innerHeight;
    this.stickyElementHeight = 0;
    this.endScroll = 0;

    // Bind methods to the instance
    this._boundUpdateSticky = this.updateSticky.bind(this);
    this._boundHandleResize = this.handleResize.bind(this);
  }

  // Called when the element is added to the DOM
  connectedCallback(): void {
    this.initSidebar();
    window.addEventListener("scroll", this._boundUpdateSticky, { passive: true });
    window.addEventListener("resize", this._boundHandleResize);
    this.updateSticky();
  }

  // Remove listeners if element is removed
  disconnectedCallback(): void {
    window.removeEventListener("scroll", this._boundUpdateSticky);
    window.removeEventListener("resize", this._boundHandleResize);
  }

  // Initialize sidebar properties based on attributes
  initSidebar(): void {
    const navEl = document.querySelector('#topNavigation');
    if (navEl) {
      this.topGap += navEl.offsetHeight;
    }

    if (this.hasAttribute("data-top-gap")) {
      const dataTopGap = this.getAttribute("data-top-gap");
      if (dataTopGap) {
        this.topGap += parseInt(dataTopGap, 10);
      }
    }

    if (this.hasAttribute("data-bottom-gap")) {
      const dataBottomGap = this.getAttribute("data-bottom-gap");
      if (dataBottomGap) {
        // console.log('dataBottomGap', dataBottomGap)
        this.bottomGap += parseInt(dataBottomGap, 10);
      }
    }

    this.style.top = this.topGap + "px";
    this.stickyElementHeight = this.offsetHeight;
  }

  // Handle window resize events
  handleResize(): void {
    this.screenHeight = window.innerHeight;
    this.stickyElementHeight = this.offsetHeight;
    this.currPos = window.scrollY;
    this.updateSticky();
  }

  updateSticky(): void {
    requestAnimationFrame(() => {
      this.screenHeight = window.innerHeight;
      this.stickyElementHeight = this.offsetHeight;
      this.positionStickySidebar();
    });
  }

  // Calculate and set the new position of the sticky sidebar
  positionStickySidebar(): void {
    const headerElement = document.querySelector('header.section-header') as HTMLElement | null;
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;
    
    // Account for sticky sidebar and navigation in positioning
    const adjustedTopGap = this.topGap + headerHeight;
    const adjustedBottomGap = this.bottomGap;

    this.endScroll = window.innerHeight - this.stickyElementHeight - adjustedBottomGap;
    let currentTop = parseInt(this.style.top.replace("px", ""), 10);
    let scrollDelta = this.currPos - window.scrollY;
    let newTop: number;
    
    if (this.stickyElementHeight + adjustedTopGap + adjustedBottomGap > this.screenHeight) {
      if (scrollDelta > 0) {
        newTop = Math.min(currentTop + scrollDelta, adjustedTopGap);
      } else {
        newTop = Math.max(currentTop + scrollDelta, this.endScroll);
      }
    } else {
      newTop = adjustedTopGap;
    }

    this.style.top = newTop + "px";
    this.style.bottom = adjustedBottomGap + "px";
    this.currPos = window.scrollY;
  }
}

customElements.define("sticky-sidebar", StickySidebar);

